import { faqArticleBodySchema } from "@redotech/redo-model/faq/faq-body-schema";
import * as z from "zod/v4";

export const getFaqArticles = {
  name: "getFaqArticles" as const,
  input: z.object({}),
  output: z.object({ articles: z.array(faqArticleBodySchema) }),
};
